import React, { useState } from 'react';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import './style.css'

export function CalendarRange(props) {
    const startDate = props.startDate
    const setStartDate = props.setStartDate
    const endDate = props.endDate
    const setEndDate = props.setEndDate
    return (
      <>
        <DatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          className='birthday'
          dateFormat="dd-MM-yyyy"
        />
        <DatePicker
          selected={endDate}
          onChange={(date) => setEndDate(date)}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          className='birthday mt-5px'
          dateFormat="dd-MM-yyyy"
        />
      </>
    );
}